import slice, {
    separateProducts,
    setSeparatedProductsOpen,
    updateSeparatedProducts,
} from './separatedProducts.slice';
export { separateProducts, setSeparatedProductsOpen, updateSeparatedProducts };
export default slice.reducer;
